import React, {FC, useState} from "react";
import {TextField} from "@mui/material";

type Props = {
  value: string,
  onChange: (value: string) => void,
  label: string
  onErrorChange: (error: string|undefined) => void,
  required: boolean
}

export const MathTextField: FC<Props> = ({ value, onChange, label,onErrorChange,required}) => {
  const [error, setError] = useState<string>()
  const regex = /^(\d+|n|g)((\*|\+)(\d+|n|g))?((\*|\+)(\d+|n|g))?$/
  const onClick = (newValue:string) => {
    if( regex.test(newValue) || (!required && newValue==="")){
      setError(undefined)
      onErrorChange(undefined)
    } else {
      setError("Niepoprawny format")
      onErrorChange("Niepoprawny format")
    }
    onChange(newValue)

  }
  return (
    <TextField
      label={label}
      value={value}
      onChange={(e) => {
        onClick(e.target.value)
      }}
      error={!!error}
      helperText={"Wpisz liczbę lub n(ID) lub g(wycena) np. 2*n+3 lub 2 lub 2+n etc"}
    />
  )
}